export const NDVI_KEY = 'ndvi';
